import { IChatHistory, IChatHistoryList } from "modules/gpo-agent/models/chat-history/chat-history-list.model";
import { IChatHistoryMessages } from "modules/gpo-agent/models/chat-history/chat-history-messages.model";
import { IReferenceDocumentsResponse } from "modules/gpo-agent/models/chat-history/reference-documents-response.model";

interface IAgentsChatHistoryState{
    chatHistoryMessageHandoffGuid:string;
    chatHistoryList: IChatHistoryList|undefined,
    chatHistoryMessages:IChatHistoryMessages|undefined,
    currentSelectedChatGuid : string,
    selectedChatHistory:IChatHistory|undefined;
    isAnnotateView:boolean;
    documentType:string;
    referenceDocuments: IReferenceDocumentsResponse|undefined;
    completeAnnotationResponse:any;
    searchMessagesText:string;
    searchText:string;
    annotateDetailsResponse:any;
    searchTextChanged:boolean;
}

const initalAgentsChatHistoryState: IAgentsChatHistoryState = {
    chatHistoryMessageHandoffGuid:"",
    chatHistoryList:undefined,
    chatHistoryMessages:undefined,
    currentSelectedChatGuid : "",
    selectedChatHistory:undefined,
    isAnnotateView:false,
    documentType:"",
    referenceDocuments:undefined,
    completeAnnotationResponse:undefined,
    searchMessagesText:"",
    searchText:"" ,
    annotateDetailsResponse:undefined,
    searchTextChanged:false
};

export { initalAgentsChatHistoryState };
